import React from 'react';
import dynamic from 'next/dynamic';
import {PriceBoxProps} from '@/_application/modules/products/components/price/price.types';

const FinalPriceConfigurable = dynamic(() =>
    import('@/_application/modules/products/components/price/configurable/final-price-configurable').then(
        m => m.FinalPriceConfigurable,
    ),
);
const FinalPriceSimple = dynamic(() =>
    import('@/_application/modules/products/components/price/simple/final-price-simple').then(m => m.FinalPriceSimple),
);

const MAP_PRICES_TO_BOX = {
    ConfigurableProduct: FinalPriceConfigurable,
    SimpleProduct: FinalPriceSimple,
};
export const PriceBox = (props: PriceBoxProps) => {
    const {product} = props;
    const PriceBoxComponent = MAP_PRICES_TO_BOX[product.__typename!]
        ? MAP_PRICES_TO_BOX[product.__typename!]
        : FinalPriceSimple;

    return <PriceBoxComponent {...props} />;
};
